import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  getProducts: () => client.get("/products").then((r) => r.data),
  joinWaitlist: (data) => client.post("/waitlist", data).then((r) => r.data),
  waitlistCount: () => client.get("/waitlist/count").then((r) => r.data),
  sendMessage: (data) => client.post("/contact", data).then((r) => r.data),
  checkout: (items, originUrl) =>
    client.post("/payments/checkout", { items, origin_url: originUrl }).then((r) => r.data),
  paymentStatus: (sessionId) => client.get(`/payments/status/${sessionId}`).then((r) => r.data),
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  adminProducts: () => client.get("/admin/products").then((r) => r.data),
  createProduct: (data) => client.post("/admin/products", data).then((r) => r.data),
  updateProduct: (id, data) => client.put(`/admin/products/${id}`, data).then((r) => r.data),
  deleteProduct: (id) => client.delete(`/admin/products/${id}`).then((r) => r.data),
  adminWaitlist: () => client.get("/admin/waitlist").then((r) => r.data),
  adminOrders: () => client.get("/admin/orders").then((r) => r.data),
  adminMessages: () => client.get("/admin/messages").then((r) => r.data),
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
